import { Typography, Divider, Box, Container } from '@mui/material'
import I18n from 'i18n-js'

import LegacySvg from '../shared/LegacySvg/LegacySvg'
import NeedHelp from '../shared/NeedHelp'

export const redirectedFlag = 'checked'

type NotFoundProps = {
  location?: Location
}

export function NotFound({ location }: NotFoundProps) {
  let render404 = true
  if (location) {
    let search = new URLSearchParams(location.search)
    if (!search.has(redirectedFlag)) {
      let newUrl = window.location.origin + location.pathname
      search.append(redirectedFlag, `${Date.now()}`)
      newUrl += `?${search}${location.hash || ''}`
      window.location.assign(newUrl)
      render404 = false
    }
  }

  if (render404) {
    return (
      <Container maxWidth="md" disableGutters>
        <Box p={4}>
          <LegacySvg
            height={`48px`}
            symbol={'pbxx_logo_colored'}
            width={`282px`}
          />
          <Box mt={4}>
            <Typography variant={'h2'}>
              {I18n.t('notFound.404PageNotFound')}
            </Typography>
            <Divider />
          </Box>
          <Box mt={4}>
            <Typography>{I18n.t('notFound.message')}</Typography>
          </Box>
          <Box mt={4}>
            <NeedHelp />
          </Box>
        </Box>
      </Container>
    )
  } else {
    return null
  }
}

export default NotFound
